import(/* webpackMode: "eager", webpackExports: ["BlogListView"] */ "/vercel/path0/frontend_next/src/components/views/BlogListView.tsx");
